import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { GlobalService } from '../global.service';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-booth-wise-customer-order',
  templateUrl: './booth-wise-customer-order.component.html',
  styleUrls: ['./booth-wise-customer-order.component.scss']
})
export class BoothWiseCustomerOrderComponent implements OnInit {
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  month_list_for_last_12_months: any = [];
  selected_month: any = null;
  entered_booth_code: any = null;
  is_data_available: boolean = true;
  booth_data: any;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  zones: any;
  selected_report_type = null;
  selected_zone_id = null;
  selected_order_type = null;
  is_pdf_available = false;
  mor_routes: any;
  selected_route_id: any = null;
  title: any = null;

  constructor(private httpService: HttpService, private dialog: MatDialog, private global: GlobalService) {
    let today = new Date();
    this.title = this.global._active_display_name;
    today.setDate(1);
    for (let i = 0; i < 1; i++) {
      today.setMonth(today.getMonth() + 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    today = new Date();
    today.setDate(1);
    let data_dict = {
      'month_in_string': this.monthNames[today.getMonth()],
      'month_in_integer': today.getMonth(),
      'year': today.getFullYear()
    };
    this.month_list_for_last_12_months.push(data_dict);
    for (let i = 0; i <= 24; i++) {
      today.setMonth(today.getMonth() - 1);
      let data_dict = {
        'month_in_string': this.monthNames[today.getMonth()],
        'month_in_integer': today.getMonth(),
        'year': today.getFullYear()
      };
      this.month_list_for_last_12_months.push(data_dict);
    }
    console.log(this.month_list_for_last_12_months);
    this.httpService.getZones().subscribe((zones: []) => {
      console.log(zones);
      this.zones = zones;
    }, (error) => {
      console.log(error);
    });
    this.httpService.getMorRoutes().subscribe((routes: []) => {
      console.log(routes);
      this.mor_routes = routes;
    }, (error) => {
      console.log(error);
    });
  }

  getClicked() {
    if (this.selected_report_type === 'zone_wise') {
      if (this.selected_zone_id == null) {
        alert('Please Select Zone');
        return false;
      }
    } else if (this.selected_report_type === 'booth_wise') {
      if (this.entered_booth_code == null) {
        alert('Please Enter Booth Code');
        return false;
      }
    } else if (this.selected_report_type === 'route_wise') {
      if (this.selected_route_id == null) {
        alert('Please Select Route');
        return false;
      }
    }
    let data_dict = {
      'selected_report_type': this.selected_report_type,
      'selected_zone_id': this.selected_zone_id,
      'entered_booth_code': this.entered_booth_code,
      'selected_month': this.selected_month,
      'selected_route_id': this.selected_route_id
    };
    console.log(data_dict);
    this.is_data_available = false;
    this.httpService.serveBulkBoothWiseCustomerOrder(data_dict).subscribe((data) => {
      console.log(data);
      this.booth_data = data;
      this.is_pdf_available = data['document_data']['data_available'];
      this.is_data_available = true;
      if (!data['document_data']['data_available']) {
        alert('No Order Avilable');
        return false;
      }
    }, (error) => {
      this.is_data_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.booth_data['document_data']['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.booth_data['document_data']['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  statementClikced(booth, index) {
    let data_dict = {
      'year': booth['year'],
      'month': booth['month'],
      'booth_code': booth['booth_code']
    };
    this.booth_data['data_list'][index]['loader'] = true;
    this.httpService.serveBoothWiseCustomerOrder(data_dict).subscribe((data) => {
      console.log(data);
      this.booth_data['data_list'][index]['loader'] = false;
      const linkSource = 'data:application/pdf;base64,' + data['pdf'];
      const downloadLink = document.createElement("a");
      const fileName = data['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }, (error) => {
      this.booth_data['data_list'][index]['loader'] = false;
    });
  }

  ngOnInit() {
  }

}
